module.exports = __webpack_public_path__ + "img/toast-indicator.2118d36c.svg";